/**
 * PaymentRow — карточка платежа в мобильном списке: иконка типа, клиент и
 * тип·период, сумма и пилюля статуса. Тап открывает detail-sheet.
 */

import type {PaymentRow as Row} from '@services/payments';
import {ClientTypeIcon} from '@pages/Clients/ClientTypeIcon';

import {amountClass, fmtSignedSom} from '../../Payments.utils';
import {PaymentStatusPill} from '../../PaymentStatusPill';

type PaymentRowProps = {
  row: Row;
  onOpen: (row: Row) => void;
};

export const PaymentRow = ({row, onOpen}: PaymentRowProps) => (
  <button
    onClick={() => onOpen(row)}
    className="flex items-center gap-3 rounded-[14px] border border-skr-line2 bg-card px-3.5 py-[13px] text-left"
  >
    <ClientTypeIcon type={row.clientType} size={40} />
    <div className="min-w-0 flex-1">
      <div className="truncate text-[14.5px] font-semibold">{row.client}</div>
      <div className="mt-0.5 text-xs text-muted-foreground">
        {row.type} · {row.period}
      </div>
    </div>
    <div className="shrink-0 text-right">
      <div className={`whitespace-nowrap font-mono text-[15px] font-semibold ${amountClass(row)}`}>
        {fmtSignedSom(row.amount)}
      </div>
      <PaymentStatusPill status={row.status} size="sm" />
    </div>
  </button>
);
